import styled from "styled-components";
import { LAYOUT } from "@/constants/styles";

export const StyledLocationHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${LAYOUT.GUTTER}px;
  width: 100%;

  h3 {
    font-size: 14px;
    line-height: 1.25;
    margin: 0 0;
    position: relative;
  }

  h4 {
    flex: 1;
    font-size: 16px;
    margin: 0;
    font-family: ${({ theme }) => theme.primary_font.medium.font_family};
  }
`;

export const StyledFavoriteOrderCTA = styled.div`
  display: flex;
  flex-wrap: wrap;

  button svg {
    max-height: 18px;
  }
`;
